// Shared constants for i18n translations
// Use these constants to avoid duplication across translation files

export const ENG_MONTHS = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
}

export const ENG_WEEKDAYS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
}

export const COMMON_UI_ACTIONS = {
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
}

export const ATTENDANCE_STATUS = {
  all: 'All',
  attendance: 'Attended',
  absent: 'Absent',
  arrived: 'Arrived',
  notYetArrived: 'Not yet arrived',
  returned: 'Returned home',
}

export const PERSON_NAME_FIELDS = {
  lastName: 'Last Name',
  firstName: 'First Name',
  lastNameKana: 'Last Name (Kana)',
  firstNameKana: 'First Name (Kana)',
}

export const STAFF_ROLES = {
  administrator: 'Administrator',
  facilityDirector: 'Facility Director',
  chief: 'Chief',
}

export const COMMON_MESSAGES = {
  exportStarted: 'Export has started.\nPlease check from the download list page.\n*It may take 1-2 minutes to complete.',
  exportFailed: 'Export failed',
}
